import { API } from '~/utils/metrics/specta/API'

export interface Labels {
  [key: string]: string
}
interface HistogramRequest {
  labels: Labels
  metric: string
  number: number
}

export function postHistogram(args: HistogramRequest) {
  if (process.env.SPECTA_ENDPOINT === undefined) return

  try {
    API.histogram({
      action: [
        { metric: args.metric, labels: args.labels, number: args.number },
      ],
    })
  } catch (err) {
    return Promise.reject(err)
  }
}
